module.exports = __webpack_public_path__ + "static/media/right-page.8a6c42f0.svg";